<template>
    <div class="row mb-2 default-inputs search-date-range-wrap">
        <div class="col-sm-12 col-md-4 col-lg-4 text-left">
            <input :disabled="disabled" class="search-input mt-4" v-model="searchValue" placeholder="Search by Model / Serial Number" />
        </div>
        <div class="col-sm-12 col-md-8 col-lg-8 text-left">
            <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 mb-3 mb-md-0 mb-xl-0">
                    <label class="mb-0">Start date</label>
                    <vuejs-datepicker
                        initial-view="year"
                        maximum-view="year"
                        v-model="startDateValue"
                        :typeable="false"
                        :full-month-name="true"
                        :format="'yyyy-MM-dd'"
                        class="search-range"
                        id="search_start_date"
                        placeholder="YY-MM-DD"
                        :disabled-dates="{from: new Date()}"
                    ></vuejs-datepicker>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 mb-3 mb-md-0 mb-xl-0">
                    <label class="mb-0">End date</label>
                    <vuejs-datepicker
                        initial-view="year"
                        maximum-view="year"
                        v-model="endDateValue"
                        :typeable="false"
                        :full-month-name="true"
                        :format="'yyyy-MM-dd'"
                        class="search-range"
                        id="search_end_date"
                        placeholder="YY-MM-DD"
                        :disabled-dates="{from: new Date()}"
                    ></vuejs-datepicker>
                </div>

                <div class="col-sm-12 col-md-4 col-lg-4">
                    <button @click="onFilterClick" class="btn btn-primary w-full rounded">Filter</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'SearchAndDdateRange',
    components: {},
    props: ['disabled', 's', 'startDate', 'endDate'],
    data() {
        return {};
    },
    computed: {
        searchValue: {
            get() {
                return this.s;
            },
            set(value) {
                this.$emit('update:s', value);
            }
        },
        startDateValue: {
            get() {
                return this.startDate;
            },
            set(value) {
                this.$emit('update:startDate', moment(value).format('YYYY-MM-DD'));
            }
        },
        endDateValue: {
            get() {
                return this.endDate;
            },
            set(value) {
                this.$emit('update:endDate', moment(value).format('YYYY-MM-DD'));
            }
        }
    },
    methods: {
        onFilterClick() {
            this.$emit('filter-click');
        }
    }
};
</script>
